import { render, staticRenderFns } from "./TypedSurveyImages.vue?vue&type=template&id=31c66dba&scoped=true"
import script from "./TypedSurveyImages.vue?vue&type=script&lang=js"
export * from "./TypedSurveyImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c66dba",
  null
  
)

export default component.exports